import { Button, Grid } from '@material-ui/core';
import GitHubIcon from '@material-ui/icons/GitHub';
import StorageIcon from '@material-ui/icons/Storage';
import React, { useState } from 'react';

import { getApiDomain, getPrInfo } from '~/src/dash/resellers/utils/importResellerConfig';

function formatPrTitle(title: string): string {
  let out = title;
  if (out.length >= 2) {
    if (out[0] === '"' && out[out.length - 1] === '"') {
      out = out.slice(1, out.length - 1);
    }
  }

  return out;
}

interface IVersionz {
  version: string;
  env: string;
}

let getVersionPr: Promise<IVersionz>;
function getVersion(): Promise<IVersionz> {
  if (!getVersionPr) {
    getVersionPr = fetch(getApiDomain() + '/versionz').then((resp) => {
      return resp.json();
    });
  }
  return getVersionPr;
}

export const DebugTopbar = () => {
  const prInfo = getPrInfo();

  const [versionz, setVersionz] = useState('');
  getVersion().then((o: IVersionz) => {
    setVersionz(o.version);
  });
  return (
    <div style={{ width: 'auto', height: 'auto', backgroundColor: '#F3A916' }}>
      <Grid container direction='row' justify='space-between' alignItems='center'>
        <Grid item xs={2}>
          <Button style={{ width: '100%', textAlign: 'left' }}>
            <StorageIcon />
            &nbsp;API: {versionz}
          </Button>
        </Grid>
        <Grid item xs={1} style={{ color: 'rgba(0, 0, 0, 0.87)', textAlign: 'center' }}>
          {prInfo.pr_owner || ''}
        </Grid>
        <Grid
          item
          xs={6}
          style={{ color: 'rgba(0, 0, 0, 0.87)', textAlign: 'center', fontWeight: 'bold' }}
        >
          {formatPrTitle(prInfo.pr_title || '')}
        </Grid>
        <Grid item xs={2}>
          <a href={prInfo.pr_url || ''}>
            <Button style={{ width: '100%' }}>
              Github&nbsp;&nbsp;
              <GitHubIcon />
            </Button>
          </a>
        </Grid>
        <Grid item xs={1}>
          <a href={`https://publica-project.atlassian.net/browse/${prInfo.pr_branch || ''}`}>
            <Button style={{ width: '100%' }}>
              Jira&nbsp;&nbsp;
              <img src='/assets/shared/svg/jira.svg' style={{ width: '1.5em', height: '1.5em' }} />
            </Button>
          </a>
        </Grid>
      </Grid>
    </div>
  );
};
